import React from 'react'
import useCategoriesBrands from '@hooks/useCategoriesBrands'
import useWebsiteId from '@hooks/useWebsiteId'
import Brands from '@page-components/Order/Products/ProductsContent/Brands'

export interface Props {
  scrollToCategory: (categoryId: string) => void
  setFilter: (any) => void
}

export default function MultiBrandSearchBar(props: Props) {
  const {scrollToCategory, setFilter} = props
  const websiteId = useWebsiteId()
  const categories = useCategoriesBrands(websiteId)

  return (
    <Brands
      categories={categories?.items}
      scrollTo={category => scrollToCategory(category)}
      onClick={() => setFilter(null)}
    />
  )
}
